import { enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { NavigationStart, Router } from '@angular/router';
// import { ɵAnimationEngine as AnimationEngine } from '@angular/animations/browser';
import { AppModule } from './app/app.module';
import { environmentConst } from './environments/environment';
import { singleSpaAngular, getSingleSpaExtraProviders } from 'single-spa-angular';
import { singleSpaPropsSubject } from './single-spa/single-spa-props';
import { loadEnvironmentVariables } from './app/modules/shared/services/util.service';

NgZone.assertInAngularZone = () => {};

if (environmentConst.production) {
  enableProdMode();
}

const lifecycles = singleSpaAngular({
  bootstrapFunction: singleSpaProps => {
    singleSpaPropsSubject.next(singleSpaProps);
    return platformBrowserDynamic([
      getSingleSpaExtraProviders(),
      { provide: 'singleSpaProps', useValue: singleSpaProps }
    ])
    .bootstrapModule(AppModule)
    .then(moduleRef => {
      const ngZone = moduleRef.injector.get(NgZone);
      return ngZone.run(() => moduleRef);
    });
  },
  template: '<app-root />',
  Router,
  NgZone,
  NavigationStart
  // AnimationEngine,
});

export const bootstrap = lifecycles.bootstrap;
export const mount = lifecycles.mount;
export const unmount = lifecycles.unmount;

loadEnvironmentVariables(window);